import { render, staticRenderFns } from "./ent-tag-detail-modal.vue?vue&type=template&id=1042ccba&"
import script from "./ent-tag-detail-modal.vue?vue&type=script&lang=js&"
export * from "./ent-tag-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ent-tag-detail-modal.vue"
export default component.exports